import * as React from "react";
import { forwardRef } from "react";
const SvgQuestionMark = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10 14.2712V14.2295M10 12.1878C10 9.63782 12.5 10.817 12.5 8.26749C12.5 4.88349 7.5 4.88349 7.5 8.26749", stroke: "#A4A5AA", strokeWidth: 0.833333, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("circle", { cx: 10.0013, cy: 10.0003, r: 7.91667, stroke: "#A4A5AA", strokeWidth: 0.833333 }));
const ForwardRef = forwardRef(SvgQuestionMark);
export { ForwardRef as ReactComponent };
